<div class="manual-play-bet-wrapper">
  <div class="manual-play-bet-container">

    <swiper-container slides-per-view="1" space-between="0" [navigation]="isSimpleBet" centered-slides="true"
      [cssMode]="!isSimpleBet"><!--[slidesPerView]="1" [spaceBetween]="0" [navigation]="isSimpleBet" [centeredSlides]="true" [cssMode]="!isSimpleBet" TODO ANGULAR16-->
      @for (bet of bets; track bet; let k = $index) {
        <swiper-slide>
          <div class="bet-element">
            <div class="bet-container" [ngStyle]="styleBetHeight()">
              <div class="element-header">
                <div class="element-action-wrapper">
                  @if (bet.currentAction == 'auto') {
                    <button class="action-automatic" [value]="bet.label"
                    (click)="createRandomManualBet(bet)">Automático</button>
                  }
                  @if (bet.currentAction == 'clear') {
                    <button class="action-automatic" [value]="bet.label"
                    (click)="clearBet(bet)">Borrar</button>
                  }
                </div>
              </div>
              <div class="element-body">
                <div class="element-numbers-wrapper">
                  @for (row of bet.mainMatrix; track row; let i = $index) {
                    <div class="element-row">
                      @for (column of bet.mainMatrix[i]; track column; let j = $index) {
                        <div class="element-column">
                          @if (i == 0 && j == 0) {
                            <button class="element-number-wrapper Alabel">
                              A{{ bet.label }}
                            </button>
                          }
                          @if (bet.mainMatrix[i][j]) {
                            <button class="element-number-wrapper " [ngStyle]="styleBet()"
                              [ngClass]="bet.numbersChecked.includes(bet.mainMatrix[i][j]) ? 'checked' : null"
                              [value]="bet.mainMatrix[i][j]"
                              (click)="checkCell(bet.mainMatrix[i][j], k, false)">
                              {{ bet.mainMatrix[i][j] }}
                            </button>
                          }
                          @if (!bet.mainMatrix[i][j] && i != 0 && j != 0) {
                            <button class="element-number-wrapper blank"
                            ></button>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (bet.extraMatrix.length > 0 && (options.idGame == 3 || options.idGame == 5 || options.idGame == 2)) {
                  <div class="element-stars-wrapper"
                    >
                    @for (row of bet.extraMatrix; track row; let i = $index) {
                      <div class="element-row">
                        @for (column of bet.extraMatrix[i]; track column; let j = $index) {
                          <div class="element-column"
                            >
                            @if (bet.extraMatrix[i][j] != null) {
                              <button class="element-star-wrapper"
                                [ngClass]="bet.extraChecked.includes(bet.extraMatrix[i][j]) ? 'checked' : null"
                                [value]="bet.extraMatrix[i][j]"
                                (click)="checkCell(bet.extraMatrix[i][j], k, true)" [ngStyle]="styleBet()">
                                <span class="number">{{ bet.extraMatrix[i][j] }}</span>
                              </button>
                            }
                            @if (!bet.extraMatrix[i][j] && i != 0 && j != 0) {
                              <button class="element-number-wrapper blank"
                              ></button>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </swiper-slide>
      }

    </swiper-container>


    @if (options.idGame == 4) {
      <div class="extra-wrapper">
        <div>
          <span style="align-self: flex-start;">Reintegro</span>
          <div class="container-stars-wrapper">
            @for (row of extraGame; track row; let i = $index) {
              <div class="element-row">
                @for (column of extraGame[i]; track column; let j = $index) {
                  <div class="element-column">
                    @if (extraGame[i][j] != null) {
                      <button class="element-star-wrapper"
                        [ngClass]="extraGameChecked.includes(extraGame[i][j]) ? 'checked' : null"
                        [value]="extraGame[i][j]"
                        (click)="checkExtraCell(extraGame[i][j])" [ngStyle]="styleBet()">
                        {{ extraGame[i][j] }}
                      </button>
                    }
                    @if (!extraGame[i][j] && extraGame[i][j] == null) {
                      <button class="element-number-wrapper blank"></button>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }



  </div>
</div>